import { makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SkanskaColorTokens } from "../style/colors";

const useStyles = makeStyles({
  root: {
    textAlign: "center",
    marginTop: "100px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  paragraph: {
    fontSize: "20px",
    margin: "auto",
    marginBottom: "10px",
  },
  link: {
    fontSize: "20px",
    color: SkanskaColorTokens.color_primary_blue,
  },
  header: {
    fontSize: "80px",
  },
});

const PageNotFound = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <h1 className={classes.header}>404</h1>
      <p className={classes.paragraph}>{t("pageNotFound")}</p>
      <p className={classes.paragraph}>
        {t("click")}{" "}
        <Link className={classes.link} to={"/"}>
          {t("here")}
        </Link>{" "}
        {t("returnHome")}
      </p>
    </div>
  );
};

export default PageNotFound;
